const BASE = process.env.REACT_APP_API_URL || "https://lightslategrey-mole-360881.hostingersite.com/api";

async function userFetch(endpoint, options = {}) {
  const token = localStorage.getItem("kkb_token");
  const cfg = {
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    credentials: "include",
    ...options,
  };
  if (cfg.body && typeof cfg.body === "object")
    cfg.body = JSON.stringify(cfg.body);

  const res = await fetch(`${BASE}${endpoint}`, cfg);
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Request failed");
  return data;
}

export const uGet = (url, params = {}) => {
  const qs = new URLSearchParams(
    Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== ""),
    ),
  ).toString();
  return userFetch(`${url}${qs ? "?" + qs : ""}`);
};

export const uPost = (url, body) => userFetch(url, { method: "POST", body });
export const uPut = (url, body) => userFetch(url, { method: "PUT", body });
export const uDelete = (url) => userFetch(url, { method: "DELETE" });
